/**
 * Collection page: off-canvas filter panel on mobile.
 *
 * The panel is a static sidebar on desktop, so this only manages the mobile
 * open/close state, the backdrop, and focus handling.
 */
(() => {
  const PANEL = '[data-pt-filter-panel]';

  let backdrop = null;
  let lastFocused = null;

  const ensureBackdrop = () => {
    if (backdrop) return backdrop;

    backdrop = document.createElement('div');
    backdrop.className = 'pt-filter-backdrop';
    backdrop.hidden = true;
    backdrop.addEventListener('click', () => closeAll());
    document.body.appendChild(backdrop);
    return backdrop;
  };

  const openPanels = () => document.querySelectorAll(`${PANEL}.is-open`);

  const closeAll = () => {
    openPanels().forEach((panel) => {
      panel.classList.remove('is-open');
      panel
        .closest('.pt-collection')
        ?.querySelectorAll('[data-pt-filter-toggle]')
        .forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    });

    ensureBackdrop().hidden = true;
    document.body.style.overflow = '';
    if (lastFocused instanceof HTMLElement) lastFocused.focus();
  };

  const open = (panel, trigger) => {
    lastFocused = trigger;
    panel.classList.add('is-open');
    panel
      .closest('.pt-collection')
      ?.querySelectorAll('[data-pt-filter-toggle]')
      .forEach((btn) => btn.setAttribute('aria-expanded', 'true'));

    ensureBackdrop().hidden = false;
    document.body.style.overflow = 'hidden';
    panel.querySelector('.pt-collection__sidebar-close')?.focus();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-pt-filter-toggle]');
    if (!toggle) return;

    const panel = toggle.closest('.pt-collection')?.querySelector(PANEL);
    if (!panel) return;

    event.preventDefault();
    if (panel.classList.contains('is-open')) {
      closeAll();
    } else {
      open(panel, toggle);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openPanels().length) closeAll();
  });

  // Desktop turns the panel back into a static column; drop the mobile state.
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990 && openPanels().length) closeAll();
  });
})();
